module.exports = __webpack_public_path__ + "img/sm_app.6476457d.png";